import React from "react"
import type { ColorResult } from "react-color"
import styles from "./ColorSwatches.module.scss"
import { swatches } from "./swatches"
import clsx from "clsx";

interface Props {
  color: string
  handleColorChange?: (color: ColorResult) => void
  name?: string
  popover?: boolean
}

export const ColorSwatches: React.FC<Props> = ({ color, handleColorChange, name }) => {
  const [localColor, setLocalColor] = React.useState<string>(color)

  const handleChange = (color: ColorResult) => {
    if (handleColorChange) {
      handleColorChange(color)
    }
    setLocalColor(color.hex)
  }

  return (
    <div className={clsx({
      [styles.swatchesContainer]: true,
    })}>
      <div className={styles.swatchesGrid}>
        {swatches.map((swatch, index) => (
          <button
            type={"button"}
            key={index}
            className={`${styles.colorSwatch} ${localColor === swatch ? styles.selected : ""}`}
            style={{ backgroundColor: swatch }}
            onClick={() => handleChange({ hex: swatch } as ColorResult)}
          />
        ))}
      </div>
      <input type="hidden" name={name} value={localColor} />
    </div>
  )
}

export default ColorSwatches

